<template>
    <div class="login-container">
      <h2>Login</h2>
      <form @submit.prevent="login">
        <div>
          <label for="username">Username:</label>
          <input type="text" v-model="username" id="username" required />
        </div>
        <div>
          <label for="password">Password:</label>
          <input type="password" v-model="password" id="password" required />
        </div>
        <button type="submit">Login</button>
      </form>
      <p v-if="errorMessage">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import axios from 'axios';
  import { useRouter } from 'vue-router';
  import { API_BASE_URL } from '../config'
  
  const username = ref('');
  const password = ref('');
  const errorMessage = ref('');
  const router = useRouter();
  
  async function login() {
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, {
        username: username.value,
        password: password.value,
      });
      const token = response.data.token;
  
      // Save the token in localStorage or a cookie
      localStorage.setItem('jwtToken', token);
  
      // Navigate to a protected route
      router.push('/');
    } catch (error) {
      errorMessage.value = 'Invalid username or password.';
    }
  }
  </script>
  
  <style scoped>
  .login-container {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }
  </style>
  